import { IState } from "store/index";

export const schemaDetailSelector = (state: IState) => state.app.schema.detail;
export const schemaDimSelector = (state: IState) => state.app.schema.dimensions;
export const schemaIsLoadedSelector = (state: IState) =>
  state.app.schema.isLoaded;

export const currentSchemaSelector = (state: IState) =>
  state.app.schema.dimensions.schema_name;
